import styled from 'styled-components'

interface PageTitleProps {
  titleName?: string
}

export const PageTitle = styled.h2<PageTitleProps>`
  max-width: 62.5rem;
  font-weight: 700;
  font-family: 'Caixa Std', sans-serif;
  font-size: 28px;
  line-height: 120%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => (props.titleName === '' ? 'var(--red)' : 'none')};
  white-space: nowrap;
  margin-bottom: 0;

  @media (max-width: 768px) {
    font-size: 21px;
  }
`

export const PageDescription = styled.p`
  font-family: 'Caixa Std', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 2rem
`

export const ManagementPageDescription = styled.p`
  font-family: 'Caixa Std';
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  margin-top: 4px;
  margin-bottom: 0;
`

export const Wrapper = styled.div`
  margin-bottom: 16px;
`
